import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const PlatformContext = createContext(null);

const DEFAULT_SOURCES = {
  documents: { enabled: false, url: '' },
  axiom: { enabled: false },
  repos: { enabled: false, repositories: [] },
};

export function PlatformProvider({ children }) {
  const { user, token } = useAuth();
  const [sources, setSources] = useState(DEFAULT_SOURCES);
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user || !token) {
      setSources(DEFAULT_SOURCES);
      setInitialized(false);
      return;
    }

    async function fetchConfig() {
      setLoading(true);
      try {
        const res = await fetch('/api/platform/config', {
          headers: { 'Authorization': `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          setSources(data.sources || DEFAULT_SOURCES);
          setInitialized(true);
        }
      } catch {
        // silently fail — sources stay at defaults
      } finally {
        setLoading(false);
      }
    }

    fetchConfig();
  }, [user, token]);

  return (
    <PlatformContext.Provider value={{ sources, initialized, loading }}>
      {children}
    </PlatformContext.Provider>
  );
}

export function usePlatform() {
  const ctx = useContext(PlatformContext);
  if (!ctx) throw new Error('usePlatform must be used within PlatformProvider');
  return ctx;
}
